import { sharedHandleError } from './shared';
import '$lib/logging/client-logger';

export const handleError = sharedHandleError;
